/* Detect if browser is Touch, can do css filters or object-fit,
You can add new detections with the link::
*/

/*! modernizr 3.6.0 (Custom Build) | MIT -- You can add new detections with the link:: *
 * https://modernizr.com/download/?-cssfilters-objectfit-touchevents-setclasses-cssclassprefix:mod- !*/

 !function(e,t,n){function r(e,t){return typeof e===t}function o(){var e,t,n,o,s,i,a;for(var l in S)if(S.hasOwnProperty(l)){if(e=[],t=S[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(o=r(t.fn,"function")?t.fn():t.fn,s=0;s<e.length;s++)i=e[s],a=i.split("."),1===a.length?Modernizr[a[0]]=o:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=o),C.push((o?"":"no-")+a.join("-"))}}function s(e){var t=_.className,n=Modernizr._config.classPrefix||"";if(b&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),b?_.className.baseVal=t:_.className=t)}function i(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):b?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function a(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function l(){var e=t.body;return e||(e=i(b?"svg":"body"),e.fake=!0),e}function u(e,n,r,o){var s,a,u,f,c="modernizr",p=i("div"),d=l();if(parseInt(r,10))for(;r--;)u=i("div"),u.id=o?o[r]:c+(r+1),p.appendChild(u);return s=i("style"),s.type="text/css",s.id="s"+c,(d.fake?d:p).appendChild(s),d.appendChild(p),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(t.createTextNode(e)),p.id=c,d.fake&&(d.style.background="",d.style.overflow="hidden",f=_.style.overflow,_.style.overflow="hidden",_.appendChild(d)),a=n(p,e),d.fake?(d.parentNode.removeChild(d),_.style.overflow=f,_.offsetHeight):p.parentNode.removeChild(p),!!a}function f(e,t){return!!~(""+e).indexOf(t)}function c(e,t){return function(){return e.apply(t,arguments)}}function p(e,t,n){var o;for(var s in e)if(e[s]in t)return n===!1?e[s]:(o=t[e[s]],r(o,"function")?c(o,n||t):o);return!1}function d(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function m(t,n,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,t,n);var s=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(s){var i=s.error?"error":"log";s[i].call(s,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!n&&t.currentStyle&&t.currentStyle[r];return o}function v(t,r){var o=t.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(d(t[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var s=[];o--;)s.push("("+d(t[o])+":"+r+")");return s=s.join(" or "),u("@supports ("+s+") { #modernizr { position: absolute; } }",function(e){return"absolute"==m(e,null,"position")})}return n}function h(e,t,o,s){function l(){c&&(delete A.style,delete A.modElem)}if(s=r(s,"undefined")?!1:s,!r(o,"undefined")){var u=v(e,o);if(!r(u,"undefined"))return u}for(var c,p,d,m,h,y=["modernizr","tspan","samp"];!A.style&&y.length;)c=!0,A.modElem=i(y.shift()),A.style=A.modElem.style;for(d=e.length,p=0;d>p;p++)if(m=e[p],h=A.style[m],f(m,"-")&&(m=a(m)),A.style[m]!==n){if(s||r(o,"undefined"))return l(),"pfx"==t?m:!0;try{A.style[m]=o}catch(g){}if(A.style[m]!=h)return l(),"pfx"==t?m:!0}return l(),!1}function y(e,t,n,o,s){var i=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+E.join(i+" ")+i).split(" ");return r(t,"string")||r(t,"undefined")?h(a,t,o,s):(a=(e+" "+k.join(i+" ")+i).split(" "),p(a,t,n))}function g(e,t,r){return y(e,n,n,t,r)}var C=[],S=[],x={_version:"3.6.0",_config:{classPrefix:"mod-",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){S.push({name:e,fn:t,options:n})},addAsyncTest:function(e){S.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=x,Modernizr=new Modernizr;var _=t.documentElement,b="svg"===_.nodeName.toLowerCase(),w=x._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];x._prefixes=w;var T="CSS"in e&&"supports"in e.CSS,j="supportsCSS"in e;Modernizr.addTest("supports",T||j);var z=x.testStyles=u;Modernizr.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var r=["@media (",w.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");z(r,function(e){n=9===e.offsetTop})}return n});var P="Moz O ms Webkit",E=x._config.usePrefixes?P.split(" "):[];x._cssomPrefixes=E;var N=function(t){var r,o=w.length,s=e.CSSRule;if("undefined"==typeof s)return n;if(!t)return!1;if(t=t.replace(/^@/,""),r=t.replace(/-/g,"_").toUpperCase()+"_RULE",r in s)return"@"+t;for(var i=0;o>i;i++){var a=w[i],l=a.toUpperCase()+"_"+r;if(l in s)return"@-"+a.toLowerCase()+"-"+t}return!1};x.atRule=N;var k=x._config.usePrefixes?P.toLowerCase().split(" "):[];x._domPrefixes=k;var L={elem:i("modernizr")};Modernizr._q.push(function(){delete L.elem});var A={style:L.elem.style};Modernizr._q.unshift(function(){delete A.style}),x.testAllProps=y,x.testAllProps=g,Modernizr.addTest("cssfilters",function(){if(Modernizr.supports)return g("filter","blur(2px)");var e=i("a");return e.style.cssText=w.join("filter:blur(2px); "),!!e.style.length&&(t.documentMode===n||t.documentMode>9)});var O=x.prefixed=function(e,t,n){return 0===e.indexOf("@")?N(e):(-1!=e.indexOf("-")&&(e=a(e)),t?y(e,t,n):y(e,"pfx"))};Modernizr.addTest("objectfit",!!O("objectFit"),{aliases:["object-fit"]}),o(),s(C),delete x.addTest,delete x.addAsyncTest;for(var R=0;R<Modernizr._q.length;R++)Modernizr._q[R]();e.Modernizr=Modernizr}(window,document);


if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
        arrows: false
    });


    //event
    const eventsType = document.querySelectorAll('.js-event-type');
    const eventsCategory = document.querySelectorAll('.js-event-category');
    const events = document.querySelectorAll('.js-event');
    const resetEvent = document.getElementById('reset-event');


    let prevTabType = null;
    let prevTabCategory = null;

    eventsType.forEach(tab => {
        tab.addEventListener("click", () => {
            if(prevTabCategory){
                prevTabCategory.classList.remove("active");
            }
            tab.classList.toggle("active");
            prevTabCategory = tab;
            initTabs()
        })
    })


    eventsCategory.forEach(tab => {
        tab.addEventListener("click", () => {
            if(prevTabType){
                prevTabType.classList.remove("active");
            }
            tab.classList.toggle("active");
            prevTabType = tab;
            initTabs() 
        })
    })


    const initTabs = () => {
        
            let valueTab = [];
            document.querySelectorAll('.js-all-event-tabs .active').forEach(activeTab => {
                valueTab.push(activeTab.dataset.filter)
            })

            
            events.forEach( eventItem => {
                let filters = eventItem.dataset.filters.split(' ');
                let found;
                if (document.querySelector('ul.type li.active') && document.querySelector('ul.category li.active')){
                    found = filters.every(filter => valueTab.includes(filter));
                }else{
                    found = filters.some(filter => valueTab.includes(filter));
                }
                if(found){
                    eventItem.classList.remove("hidden");
                }else{
                    eventItem.classList.add("hidden");
                }
            })

    }

    const eventReset = () => {
        resetEvent.addEventListener('click' , () => {
            events.forEach((event) => {
                event.classList.remove("hidden");
            } )
            eventsCategory.forEach((category) => {
                category.classList.remove("active");
            } )
            eventsType.forEach((type) => {
                type.classList.remove("active");
            } )
        })
        
    }
    eventReset();

})();